import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer mt-6 p-2" >
            <h6>Made with ❤️ by <a href="https://www.linkedin.com/in/nazmus-sakib-developer/" >Nazmus Sakib</a> </h6>
        </div>
    );
};

export default Footer;